'use strict';

const {
  formatNum
} = require('./utilities.jsx');
module.exports = function getSpaceCancelConditions({
  space,
  people,
  services = []
}) {
  if (space.type !== 'b_seminar') {
    return 'Annulation possible jusqu\'à 4h avant l\'arrivée';
  }
  let cancel_condition = 'Annulation sans frais J-',
    cancel_delay = 2;
  const people_count = parseInt(people || 0, 10);
  const can_cancel = space.cancellation_condition === 'annulation_possible';
  if (space.cancellation_condition === 'non_remboursable') {
    cancel_condition = 'Réservation non remboursable';
    cancel_delay = '';
  } else {
    if (can_cancel) {
      cancel_delay = formatNum(space.cancellation_condition_duration, '0');
    }
    const has__catering = services.some(function (service) {
      const titles = ['Menu 3 plats (Entrée-Plat-Dessert)', 'Menu 2 plats (Entrée-Plat ou Plat-Dessert)'];
      const service_title = service.service_info._servicetitle ? service.service_info._servicetitle.title : service.service_info.title;
      return titles.some(title => (service_title || '').includes(title));
    });
    if (has__catering) {
      cancel_delay = people_count < 16 ? 7 : 14;
    }
  }
  return cancel_condition + cancel_delay;
};
